<template>
  <div>
    <page-header
      :actions="pageHeaderActionsConfig"
      :page="pageHeaderConfig"
      right-side-class="col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
    />
    <validation-observer ref="searchServiceRef">
      <div class="search-top-form-wrapper">
        <div class="search-top-form bg-secondary-3 rounded p-3 px-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="row">
              <div class="col-12 col-md-4 label-input mb-2 mb-md-0">
                Año fiscal:
              </div>
              <div class="col-12 col-md-7">
                <custom-drop-down
                  v-model="selectedFilters.academicYear"
                  :clearable="false"
                  custom-error-msg="Favor seleccione año fiscal."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="description"
                  :options="filters.academicYears"
                  placeholder="Seleccione año fiscal"
                />
              </div>
            </div>
          </validation-provider>
        </div>
      </div>

      <custom-separator
        ref="separatorElement"
        class="my-4"
        :options="sectionsSeparator"
        :pill-mode="true"
        @selected="changeSection"
      />

      <filter-manager
        v-model="selectedFilters"
        class="service-proposal-evaluators__filter-manager mb-4"
        :display-advanced="false"
        :filters="filtersConfig"
        @search="searchHandler"
      />
    </validation-observer>

    <custom-result-not-found
      v-if="showNotFound"
      text="No hay información disponible"
    />

    <div v-if="!isAvailableSection">
      <evaluator-row-standard
        v-for="(item, index) in results.selected.data"
        :key="`rows-list-selected-${index}`"
        :available="false"
        class="mb-3"
        :index="index"
        :is-visible-delete-button="isCurrentFutureYearType"
        :proposal-types="filters.proposalTypes"
        :provider-types="filters.providerTypes"
        :value="item"
        @edit="editHandler"
        @remove="removeHandler"
      />
      <pagination
        v-if="showPagination"
        :data="results.selected.pagination"
        :show-text="true"
        @pagination-go-page="onPageChange"
      />
    </div>

    <div v-if="isAvailableSection">
      <evaluator-row-standard
        v-for="(item, index) in results.available.data"
        :key="`rows-list-selected-${index}`"
        :available="true"
        class="mb-3"
        :index="index"
        :proposal-types="filters.proposalTypes"
        :provider-types="filters.providerTypes"
        :value="item"
        @add="addHandler"
      />
      <pagination
        v-if="showPagination"
        :data="results.available.pagination"
        :show-text="true"
        @pagination-go-page="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import CustomSeparator from 'custom-separator';
import alertMixin from 'utils/mixins/alert.mixin';
import PageHeader from 'PageHeader';
import CustomDropDown from 'custom-drop-down';
import FilterManager from 'FilterManager';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from '@/components/common/Pagination';

import EvaluatorRowStandard from '@/views/provider/proposalHistory/components/EvaluatorRowStandard.vue';

import {
  getInitFiltersEvaluators,
  getUnselectedEvaluators,
  getSelectedEvaluators,
  addEvaluatorUser,
  editEvaluatorUser,
  removeEvaluatorUser,
} from '@/modules/serviceProposalHistory/api';

const usersDefault = {
  selected: {
    data: [],
    pagination: {
      count: 20,
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 0,
    },
  },
  available: {
    data: [],
    pagination: {
      count: 20,
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 0,
    },
  },
};

export default {
  name: 'ServiceProposalEvaluator',
  components: {
    PageHeader,
    CustomSeparator,
    CustomDropDown,
    FilterManager,
    CustomResultNotFound,
    EvaluatorRowStandard,
    Pagination,
  },
  mixins: [alertMixin],
  data() {
    return {
      pageHeaderConfig: {
        icon: 'fas fa-user-tie',
        title: 'Manejo de Evaluadores',
        routes: ['Proveedor', 'Manejo de Evaluadores'],
      },
      selectedFilters: {
        username: null,
        academicYear: this.$store.state.$_common.currentAcademicYear,
        role: null,
        proposalTypes: [],
        providerTypes: [],
      },
      filters: {
        academicYears: [],
        roles: [],
        proposalTypes: [],
        providerTypes: [],
      },
      currentSection: 'selected',
      results: { ...usersDefault },
      pagination: {
        totalItemCount: 0,
        count: 0,
        pageCount: 0,
        currentPage: 1,
      },
    };
  },
  computed: {
    showNotFound() {
      return (this.results[this.currentSection]?.data?.length || 0) == 0;
    },
    sectionsSeparator() {
      const sections = [
        {
          id: 'selected',
          name: 'Listado de Evaluadores Seleccionados',
          active: !this.isAvailableSection,
        },
        {
          id: 'available',
          name: 'Listado de Usuarios Disponibles',
          active: this.isAvailableSection,
        },
      ];

      if (
        !this.isAvailableSection &&
        !this.isCurrentFutureYearType(this.selectedFilters.academicYear?.id)
      ) {
        sections.pop();
      }

      return sections;
    },
    showPagination() {
      const result = this.results[this.currentSection];
      return (
        result.data.length > 0 &&
        result.pagination.totalItemCount > result.pagination.count
      );
    },
    isAvailableSection() {
      return this.currentSection !== 'selected';
    },
    pageHeaderActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.go(-1),
        },
      ];
    },
    filtersConfig() {
      const { username, role } = this.selectedFilters;
      const isInValid = [username, role].every((x) => !x);

      return [
        {
          name: 'username',
          component: 'CustomInput',
          placeholder: 'Escriba Nombre o Usuario',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-8',
          returnModel: true,
          error: 'Favor escriba nombre o usuario.',
          ...(isInValid ? {} : {}),
        },
        {
          name: 'role',
          component: 'CustomDropDown',
          options: this.filters.roles,
          placeholder: 'Seleccione Rol',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          error: 'Favor selecciona un rol.',
          class: 'col-12 col-md-4',
          ...(isInValid ? {} : {}),
        },
      ];
    },
  },
  watch: {
    currentSection() {
      this.results = { ...usersDefault };
      this.selectedFilters.username = null;
      this.selectedFilters.role = null;
      this.$refs.searchServiceRef.reset();
    },
    'selectedFilters.academicYear'(academicYear) {
      this.results = { ...usersDefault };
      this.selectedFilters.username = null;
      this.selectedFilters.role = null;
      if (!this.isCurrentYearType(academicYear?.id)) {
        this.$refs.separatorElement.changeOption(0);
      }
    },
  },
  async created() {
    await this.initFilters();
    await this.search();
  },
  methods: {
    onPageChange(page) {
      this.results[this.currentSection].currentPage = page;
      this.$set(this.results[this.currentSection], 'payload', {
        ...this.results[this.currentSection].payload,
        pageIndex: page,
      });
      this.search(false);
    },
    async initFilters() {
      await getInitFiltersEvaluators().then((res) => {
        this.selectedFilters = {
          ...this.selectedFilters,
          ...res.data.filters,
        };

        const { collections } = res.data;
        this.filters = {
          ...this.filters,
          academicYears: collections.academicYears || [],
          roles: collections.roles || [],
          proposalTypes: collections.proposalTypes || [],
          providerTypes: collections.providerTypes || [],
        };
      });
    },
    async searchHandler() {
      this.search();
    },
    async search(clear = true) {
      if (clear) {
        this.results[this.currentSection].currentPage = 1;
      }
      const currentSection = this.currentSection;
      const httpRequest = {
        available: getUnselectedEvaluators,
        selected: getSelectedEvaluators,
      };
      const currentAction = httpRequest[currentSection];

      const payload = {
        searchText: this.selectedFilters.username,
        roleId: this.selectedFilters.role?.id,
        academicYearId: this.selectedFilters.academicYear.id,
        pageIndex: this.results[this.currentSection].currentPage,
      };

      await currentAction(payload)
        .then(async ({ data }) => {
          const pagination = {
            count: data.count,
            currentPage: data.currentPage,
            pageCount: data.pageCount,
            totalItemCount: data.totalItemCount,
          };

          const evaluators = await data.data.map(this.mapEvaluator);
          this.results[currentSection] = {
            ...data,
            data: evaluators,
            pagination,
          };

          this.pagination = { ...pagination };
        })
        .catch((err) => {
          if (err.response != null)
            this.Toast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    mapEvaluator(evaluatorItem) {
      return {
        academicYearId: evaluatorItem.academicYearId,
        fullName: evaluatorItem.fullName,
        user: {
          id: evaluatorItem.userId,
          name: evaluatorItem.userName,
        },
        role: {
          id: evaluatorItem.roleId,
          name: evaluatorItem.roleName,
        },
        proposalServiceEvaluatorType: evaluatorItem.proposalTypeName,
        proposalProviderType: evaluatorItem.providerTypeName,
      };
    },
    async changeSection(section) {
      this.currentSection = String(section);
      await this.search();
    },
    async addHandler(item) {
      if (!item) return;

      const value = item?.value || item?.item;
      if (!value.proposalServiceEvaluatorType || !value.proposalProviderType) {
        this.Toast('Alerta', 'Información incompleta.', 'error', 5000);
        return;
      }

      const payload = {
        academicYearId:
          value.academicYearId || this.selectedFilters.academicYear?.id,
        userId: value.user.id,
        ProviderTypeId: value.proposalProviderType.id,
        ProposalTypeId: value.proposalServiceEvaluatorType.id,
      };
      await addEvaluatorUser(payload)
        .then(() => this.$refs.separatorElement.changeOption(0))
        .then(() => this.search())
        .then(() =>
          this.Toast(
            'Proceso Exitoso',
            'El evaluador ha sido añadido exitosamente.',
            'success',
            5000
          )
        )
        .catch((err) => {
          if (err.response != null)
            this.Toast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    async editHandler(item) {
      if (!item) return;

      const value = item?.value || item?.item;
      if (!value.proposalServiceEvaluatorType || !value.proposalProviderType) {
        this.Toast('Alerta', 'Información incompleta.', 'error', 5000);
        return;
      }

      const payload = {
        academicYearId:
          value.academicYearId || this.selectedFilters.academicYear?.id,
        userId: value.user.id,
        ProviderTypeId: value.proposalProviderType.id,
        ProposalTypeId: value.proposalServiceEvaluatorType.id,
      };
      await editEvaluatorUser(payload)
        .then(() => this.search())
        .then(() =>
          this.Toast(
            'Proceso Exitoso',
            'El evaluador ha sido actualizado exitosamente.',
            'success',
            5000
          )
        )
        .catch((err) => {
          if (err.response != null)
            this.Toast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    async removeHandler(value) {
      const item = value?.item;

      if (!item) return;

      const answer = await this.ShowCancelModal(
        'Atención',
        `¿Está seguro que desea remover el usuario ${item.fullName}?`,
        'Si',
        'No'
      );

      if (!answer) return;

      const payload = {
        academicYearId:
          item.academicYearId || this.selectedFilters.academicYear?.id,
        userId: item.user.id,
      };

      this.$refs.separatorElement.changeOption(1);

      await removeEvaluatorUser(payload)
        .then(() => this.$refs.separatorElement.changeOption(1))
        .then(() => this.search())
        .then(() => {
          return this.Toast(
            'Proceso Exitoso',
            'El usuario fue removido de la lista de seleccionados exitosamente.',
            'success',
            5000
          );
        })
        .catch((err) => {
          if (err.response != null)
            this.Toast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    isCurrentYearType(academicYearId) {
      if (!academicYearId) return false;
      const currentYear = this.filters.academicYears.find(
        (y) => y.yearType === 'CURRENT'
      );
      return currentYear?.id === academicYearId;
    },
    isCurrentFutureYearType(academicYearId) {
      if (!academicYearId) return false;
      const currentFutureYear = this.filters.academicYears.find(
        (y) => y.id === academicYearId
      );
      if (!currentFutureYear) {
        return false;
      }

      return (
        currentFutureYear.yearType === 'CURRENT' ||
        currentFutureYear.yearType === 'FUTURE'
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
@import '~@/shared/scss/config/colors.scss';

.label-input {
  font-weight: bold;
  font-size: 18px;
  color: map-get($colors, 'black-');
}

.label-info {
  font-weight: normal;
  font-size: 14px;
  color: map-get($colors, 'secondary-6');
}

.info {
  font-weight: normal;
  font-size: 16px;
  color: map-get($colors, 'black');
}

@media only screen and (max-width: 768px) {
  .label {
    font-size: 12px;
  }

  .info {
    font-size: 14px;
  }
}

.search-top-form {
  width: 380px;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }

  &-wrapper {
    display: flex;
    justify-content: flex-start;
  }
}
</style>
